import { MapType } from '@/types';
import * as React from 'react';

const SIZES: MapType = {
  16: 'M8.40016 8L5.3335 4.93333L6.26683 4L10.2668 8L6.26683 12L5.3335 11.0667L8.40016 8Z',
  20: 'M10 12.8122L5 7.81217L6.16667 6.64551L10 10.4788L13.8333 6.64551L15 7.81217L10 12.8122Z',
  24: 'M12.6 12 8 7.4 9.4 6l6 6-6 6L8 16.6l4.6-4.6Z',
  40: 'M22.8264 20L16.038 13.2115C15.8072 12.9808 15.6892 12.6907 15.6838 12.3414C15.6785 11.992 15.7965 11.6966 16.038 11.4552C16.2794 11.2137 16.5722 11.093 16.9162 11.093C17.2602 11.093 17.5529 11.2137 17.7943 11.4552L25.2847 18.9456C25.4407 19.1015 25.5507 19.2661 25.6148 19.4392C25.6789 19.6122 25.711 19.7992 25.711 20C25.711 20.2009 25.6789 20.3878 25.6148 20.5609C25.5507 20.734 25.4407 20.8985 25.2847 21.0545L17.7943 28.5449C17.5636 28.7756 17.2735 28.8937 16.9242 28.899C16.5748 28.9044 16.2794 28.7863 16.038 28.5449C15.7965 28.3034 15.6758 28.0107 15.6758 27.6667C15.6758 27.3227 15.7965 27.03 16.038 26.7885L22.8264 20Z',
};

const ChevronIcon = ({ className, size }: { className?: string; size?: number }) => {
  const d = SIZES[size ?? 24];
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size ?? 24}
      height={size ?? 24}
      fill="none"
      className={className}
    >
      <path fill="currentColor" d={d} />
    </svg>
  );
};
export default ChevronIcon;
